import isEmpty from 'lodash.isempty';
import { create } from 'zustand';

const initialState = {
	zipCode: '',
	category: '',
	selectedProgram: null,
	firstName: '',
	middleName: '',
	lastName: '',
	email: '',
	mobile: '',
	dob: '',
	address: '',
	city: '',
	state: '',
	zip: '',
	genderIdent: '',
	ethnicity: '',
	race: '',
	maritalStatus: '',
	disabilityStatus: '',
	veteranStatus: '',
	last4SSN: '',
	challengeResponses: null,
	username: '',
	serviceID: undefined,
	program: undefined,
	taxonomyId: '',
	taxonomyDetail: '',
	ccaOnly: false,
	referralAgency: undefined,
	healthplan: '',
	subscriberId: '',
	status: undefined,
	skipAccountCreation: false,
	client: undefined,
	spokenLanguage: '',
	writtenLanguage: '',
	homeless: false,
	mothersName: '',
	fathersName: '',
	countryOfOrigin: '',
	isReimbursable: false,
	isExistingClient: false,
	insuranceType: '',
	medicaidPlan: '',
	textConsent: false,
	emailConsent: false,
	nickname: '',
};

export const useApplicationStore = create((set, get) => ({
	...initialState,
	setZipCode: (zipCode) => set({ zipCode }),
	setCategory: (category) => set({ category }),
	setSelectedProgram: (selectedProgram) => set({ selectedProgram }),
	setReferralAgency: (agency) => set({ referralAgency: agency }),
	setExistingClient: (client) =>
		set({
			client,
			isExistingClient: true,
			firstName: client.name_first,
			lastName: client.name_last,
			email: client.email,
			mobile: client.phone_mobile,
			dob: isEmpty(client.birth_dttm)
				? null
				: client.birth_dttm.substring(0, 10),
			address: client.address,
			city: client.city,
			state: client.state,
			zip: client.zip,
			genderIdent: client.gender,
			maritalStatus: client.marital_status,
			disabilityStatus: client.disability_status,
			veteranStatus: client.veteran_status,
			ethnicity: client.ethnicity,
			race: client.race,
			healthplan: client.health_plan_name,
			subscriberId: client.health_plan_subscriber_id,
			spokenLanguage: client.lang_spoken,
			writtenLanguage: client.lang_written,
			homeless: client.homeless,
			mothersName: client.name_mother,
			fathersName: client.name_father,
			countryOfBirth: client.country_of_birth,
			status: client.status,
			username: client.username,
			last4SSN: client.last_4_ssn,
			insuranceType: client.insurance_type,
			medicaidPlan: client.medicaid_plan,
			nickname: client.nickname,
		}),
	setNameFirst: (firstName) => set({ firstName }),
	setNameMiddle: (middleName) => set({ middleName }),
	setNameLast: (lastName) => set({ lastName }),
	setEmail: (email) => set({ email }),
	setMobile: (mobile) => set({ mobile }),
	setDob: (dob) => set({ dob }),
	setAddress: (address) => set({ address }),
	setCity: (city) => set({ city }),
	setState: (state) => set({ state }),
	setZip: (zip) => set({ zip }),
	setServiceID: (serviceID) => set({ serviceID }),
	setTaxonomyID: (taxonomyId) => set({ taxonomyId }),
	setTaxonomyDetail: (taxonomyDetail) => set({ taxonomyDetail }),
	setEthnicity: (ethnicity) => set({ ethnicity }),
	setRace: (race) => set({ race }),
	setLast4SSN: (last4SSN) => set({ last4SSN }),
	setChallengeResponses: (challengeResponses) => set({ challengeResponses }),
	setUsername: (username) => set({ username }),
	setNickname: (nickname) => set({ nickname }),
	setMaritalStatus: (maritalStatus) => set({ maritalStatus }),
	setDisibilityStatus: (disabilityStatus) => set({ disabilityStatus }),
	setVeteranStatus: (veteranStatus) => set({ veteranStatus }),
	setProgram: (program) => set({ program }),
	setHealthplan: (healthplan) => set({ healthplan }),
	setSubscriberId: (subscriberId) => set({ subscriberId }),
	setSpokenLanguage: (spokenLanguage) => set({ spokenLanguage }),
	setWrittenLanguage: (writtenLanguage) => set({ writtenLanguage }),
	setHomeless: (homeless) => set({ homeless }),
	setMothersName: (mothersName) => set({ mothersName }),
	setFathersName: (fathersName) => set({ fathersName }),
	setCountryOfBirth: (countryOfBirth) => set({ countryOfBirth }),
	setGenderIdent: (genderIdent) => set({ genderIdent }),
	setStatus: (status) => set({ status }),
	setSkipAccountCreation: (skipAccountCreation) => set({ skipAccountCreation }),
	setReimbursable: (isReimbursable) => set({ isReimbursable }),
	setInsuranceType: (insuranceType) => set({ insuranceType }),
	setMedicaidPlan: (medicaidPlan) => set({ medicaidPlan }),
	setTextConsent: (textConsent) => set({ textConsent }),
	setEmailConsent: (emailConsent) => set({ emailConsent }),
	getApplication: () => ({
		client: {
			name_first: get().firstName,
			name_middle: isEmpty(get().middleName) ? null : get().middleName,
			name_last: get().lastName,
			email: get().email,
			phone_mobile: isEmpty(get().mobile) ? null : get().mobile,
			birth_dttm: get().dob,
			id: get().client?.id,
			address: isEmpty(get().address) ? null : get().address,
			city: isEmpty(get().city) ? null : get().city,
			state: isEmpty(get().state) ? null : get().state,
			zip: isEmpty(get().zip) ? null : get().zip,
			gender: isEmpty(get().genderIdent) ? null : get().genderIdent,
			last_4_ssn: get().last4SSN,
			marital_status: isEmpty(get().maritalStatus) ? null : get().maritalStatus,
			disability_status: isEmpty(get().disabilityStatus)
				? null
				: get().disabilityStatus,
			veteran_status: isEmpty(get().veteranStatus) ? null : get().veteranStatus,
			ethnicity: isEmpty(get().ethnicity) ? null : get().ethnicity,
			race: isEmpty(get().race) ? null : get().race,
			username: get().username,
			challengeResponses: get().challengeResponses,
			health_plan_name: isEmpty(get().healthplan) ? null : get().healthplan,
			health_plan_subscriber_id: isEmpty(get().subscriberId)
				? null
				: get().subscriberId,
			lang_spoken: isEmpty(get().spokenLanguage) ? null : get().spokenLanguage,
			lang_written: isEmpty(get().writtenLanguage)
				? null
				: get().writtenLanguage,
			homeless: get().homeless,
			name_mother: get().mothersName,
			name_father: get().fathersName,
			country_of_birth: get().countryOfBirth,
			status: get().status,
			nickname: get().nickname,
			insurance_type: get().insuranceType,
			medicaid_plan: get().medicaidPlan,
			sms_opt_in_ind: get().textConsent,
			email_opt_in_ind: get().emailConsent,
		},
		request: {
			external_211_services_id: get().serviceID,
			taxonomy_id: get().taxonomyId,
			taxonomy_detail: get().taxonomyDetail,
			external_id: get().program?.id,
			reimbursable: get().isReimbursable,
		},
	}),
	getClient: () => {
		return {
			id: get().client?.id,
			name_first: get().firstName,
			name_middle: isEmpty(get().middleName) ? null : get().middleName,
			name_last: get().lastName,
			email: get().email,
			phone_mobile: isEmpty(get().mobile) ? null : get().mobile,
			birth_dttm: get().dob,
			address: isEmpty(get().address) ? null : get().address,
			city: isEmpty(get().city) ? null : get().city,
			state: isEmpty(get().state) ? null : get().state,
			zip: isEmpty(get().zip) ? null : get().zip,
			gender: isEmpty(get().genderIdent) ? null : get().genderIdent,
			last_4_ssn: get().last4SSN,
			marital_status: isEmpty(get().maritalStatus) ? null : get().maritalStatus,
			disability_status: isEmpty(get().disabilityStatus)
				? null
				: get().disabilityStatus,
			veteran_status: isEmpty(get().veteranStatus) ? null : get().veteranStatus,
			ethnicity: isEmpty(get().ethnicity) ? null : get().ethnicity,
			race: isEmpty(get().race) ? null : get().race,
			username: get().username,
			health_plan_name: isEmpty(get().healthplan) ? null : get().healthplan,
			health_plan_subscriber_id: isEmpty(get().subscriberId)
				? null
				: get().subscriberId,
			lang_spoken: isEmpty(get().spokenLanguage) ? null : get().spokenLanguage,
			lang_written: isEmpty(get().writtenLanguage)
				? null
				: get().writtenLanguage,
			homeless: get().homeless,
			name_mother: get().mothersName,
			name_father: get().fathersName,
			country_of_birth: get().countryOfBirth,
			status: get().status,
			nickname: get().nickname,
			insurance_type: get().insuranceType,
			medicaid_plan: get().medicaidPlan,
			sms_opt_in_ind: get().textConsent,
			email_opt_in_ind: get().emailConsent,
		};
	},
	setCCAOnly: (ccaOnly) => set({ ccaOnly }),
	setClientId: (clientId) =>
		set({
			client: {
				...get().client,
				id: clientId,
				setExistingClient: true,
			},
		}),
	reset: () => set(initialState),
	resetClient: () =>
		set({
			client: undefined,
			isExistingClient: false,
			firstName: '',
			middleName: '',
			lastName: '',
			email: '',
			mobile: '',
			dob: '',
			address: '',
			city: '',
			state: '',
			zip: '',
			genderIdent: '',
			maritalStatus: '',
			disabilityStatus: '',
			veteranStatus: '',
			spokenLanguage: '',
			writtenLanguage: '',
			homeless: false,
			mothersName: '',
			fathersName: '',
			countryOfOrigin: '',
			challengeResponses: null,
			username: '',
			healthplan: '',
			subscriberId: '',
			insuranceType: '',
			medicaidPlan: '',
			textConsent: false,
			emailConsent: false,
			nickname: '',
		}),
}));
